import { Form } from "react-router";
import { Button } from "@/components/ui/button";

/**
 * The two buttons about a request to join, each a post to the page's own
 * action, which takes the `join` and `withdraw` intents (Spaces and the
 * space search both do). Each says so in a toast, from the action.
 */

/** Asks to join a public space. */
export function AskToJoin({ slug, busy }: { slug: string; busy: boolean }) {
  return (
    <Form method="post">
      <input type="hidden" name="intent" value="join" />
      <input type="hidden" name="slug" value={slug} />
      <Button type="submit" size="sm" disabled={busy}>
        Ask to join
      </Button>
    </Form>
  );
}

/** Takes back a waiting request to join, in one click. */
export function WithdrawRequest({ slug, busy }: { slug: string; busy: boolean }) {
  return (
    <Form method="post">
      <input type="hidden" name="intent" value="withdraw" />
      <input type="hidden" name="slug" value={slug} />
      <Button type="submit" variant="outline" size="sm" disabled={busy}>
        Withdraw
      </Button>
    </Form>
  );
}
